import { CommonModule } from "@angular/common";
import { Component, Inject, Input, LOCALE_ID, OnChanges, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CloudinaryModule } from "@cloudinary/ng";
import { Cloudinary, CloudinaryImage } from "@cloudinary/url-gen";
import { scale } from "@cloudinary/url-gen/actions/resize";
import { Client, EntityWithTemplate, MenuConfig, SocialLinks } from "@interfaces";
import { AbstractComponent } from "src/app/page-components/abstract-component";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { ComponentActionsService } from "src/app/services/component-actions.service";
import { ComponentOverlayComponent } from "../component-overlay/component-overlay.component";

@Component({
    selector: "app-new-footer",
    standalone: true,
    imports: [CommonModule, RouterModule, CloudinaryModule, ComponentOverlayComponent],
    templateUrl: "./footer.component.html",
})
export class FooterComponent extends AbstractComponent implements OnInit, OnChanges {
    @Input() template: EntityWithTemplate;
    public logoImg!: CloudinaryImage;
    public submitted = false;
    public backgroundStyle = {};
    public buttonStyle = {};
    public socialIconStyle = {};
    public client: Client;
    public socialLinks: SocialLinks;
    public menuConfig: MenuConfig = {
        top: [],
        menuHeadings: {},
    };

    constructor(
        @Inject(LOCALE_ID) private locale,
        protected actionsService: ComponentActionsService,
        private subdomain: SubdomainService,
    ) {
        super(actionsService);
    }

    ngOnInit() {
        this.subdomain.getClient().subscribe((client: Client) => {
            this.client = client;
            this.setMenuConfig();
            this.updateLogoImg();
            this.setupSocialLinks();
        });
    }

    ngOnChanges() {
        this.setMenuConfig();
        this.updateLogoImg();
    }

    public updateLogoImg() {
        const cld = new Cloudinary({ cloud: { cloudName: "minirobot" } });
        this.logoImg = cld.image(this.client?.logo?.public_id);
        this.logoImg.resize(scale().width(100));
    }

    private setMenuConfig() {
        const menuConfig = this.template?.menuConfig ?? this.client?.menuConfig ?? this.menuConfig;
        if(!menuConfig) return;
        this.menuConfig.top = menuConfig.top
            ?.filter((h) => h.show && h.slug !== "/")
            .map((h) => ({
                ...h,
                title: this.locale && h.additionalTitles?.[this.locale] ? h.additionalTitles?.[this.locale] : h.title,
            })) ?? [];
        Object.keys(menuConfig.menuHeadings || {}).forEach((key) => {
            this.menuConfig.menuHeadings[key] = {
                ...menuConfig.menuHeadings[key],
                title:
                    this.locale && this.menuConfig.menuHeadings[key]?.additionalTitles?.[this.locale]
                        ? menuConfig.menuHeadings[key].additionalTitles?.[this.locale]
                        : menuConfig.menuHeadings[key].title,
            };
            this.menuConfig.menuHeadings[key].links = [...menuConfig.menuHeadings[key].links].filter(
                (h) => h.show && h.slug !== "/"
            );
        });
    }

    private setupSocialLinks() {
        this.socialLinks = this.client?.social;

        if(this.client?.localeData?.[this.locale]?.social) {
            this.socialLinks = this.client.localeData[this.locale].social;
        }
    }
}
